const staticPixels = "";
const pixelsCategories = ["STRICTLY_NECESSARY"];

export { staticPixels };
export { pixelsCategories };